import { useToaster } from 'react-hot-toast/headless';
import { View } from 'react-native';
import { Stack } from '@/common/components/Stack/Stack';
import { styles } from './ToastContainer.styles';

export const ToastContainer = () => {
  const { toasts, handlers } = useToaster();

  return (
    <View className={styles.root}>
      <Stack className={styles.container}>
        {toasts.map((toast) => (
          <View
            key={toast.id}
            onLayout={(event) => {
              handlers.updateHeight(toast.id, event.nativeEvent.layout.height);
            }}
          >
            {typeof toast.message === 'function'
              ? toast.message(toast)
              : toast.message}
          </View>
        ))}
      </Stack>
    </View>
  );
};
